import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const PaymentSuccess = () => {
    const { id } = useParams();
    const login = JSON.parse(localStorage.getItem("login")) || false;
    const navigate = useNavigate()
    const [data, setData] = useState({})
    const fetchTransaction = async () => {
        try {
            const response = await fetch(`https://100billionrealestate.com/payment-pay/order/${id}`)
            const res = await response.json();
            console.log(res);
            setData(res.data)
        } catch (error) {
            console.log(error);
        }

    }

    const CartEmpty = async () => {
        try {
            const response = await fetch(`https://100billionrealestate.com/cart/deleteall/${login.emplyee_ID}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json"
                }
            })
            const res = await response.json();
            if (response.ok) {
                setTimeout(() => {
                    navigate("/start-growing-your-business-at-₹1999/Month"); // 👈 Redirect to home after 2 seconds
                }, 2000);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const formatISTDateTime = (isoString) => {
        if (!isoString) return "";

        const date = new Date(isoString);

        // Convert to IST
        const ISTOffset = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in ms
        const istDate = new Date(date.getTime() + ISTOffset);

        const day = String(istDate.getDate()).padStart(2, '0');
        const month = String(istDate.getMonth() + 1).padStart(2, '0');
        const year = String(istDate.getFullYear()).slice(-2); // Last two digits
        const hours = String(istDate.getHours()).padStart(2, '0');
        const minutes = String(istDate.getMinutes()).padStart(2, '0');

        return `${day}/${month}/${year} - ${hours}:${minutes}`;
    };



    useEffect(() => {
        fetchTransaction();
        CartEmpty();
    }, [])
    return (
        <div className="hbtsuccessmainpay">
            <div className="success-card-perfume">
                <button className="success-close-perfume" >
                    <i className="fa-solid fa-xmark"></i>
                </button>
                <div className="success-header-perfume">
                    <i className="fa-solid fa-circle-check success-icon-perfume"></i>
                    <h2 className="success-title-perfume">Payment Successful</h2>
                    <p className="success-text-perfume">Thank you for your order!</p>
                    <div className="success-transaction-perfume">
                        <i className="fa-solid fa-clipboard success-clipboard-perfume"></i>
                        <span>#{data.transaction_id}</span>
                    </div>
                </div>
                <div className="success-details-perfume">
                    <div className="success-row-perfume">
                        <span>Time / Date</span>
                        <span>{formatISTDateTime(data.createdAt)}</span>
                    </div>
                    <div className="success-row-perfume">
                        <span>Ref Number</span>
                        <span>{data.transaction_id}</span>
                    </div>
                    <div className="success-row-perfume">
                        <span>Payment Method</span>
                        <span>Online</span>
                    </div>
                    <div className="success-row-perfume">
                        <span>Sender Name</span>
                        <span>{data.user_phone}</span>
                    </div>
                </div>
                <div className="success-summary-perfume">
                    <div className="success-summary-row-perfume">
                        <span>Amount</span>
                        <span>₹{data.amount / 100}</span>
                    </div>
                    <div className="success-summary-row-perfume">
                        <span>Fee</span>
                        <span>₹0</span>
                    </div>
                    <div className="success-summary-row-perfume success-total-perfume">
                        <span>Total</span>
                        <span>₹{data.amount / 100}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;
